 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/cover'
 import TEXTTITLE_PAGE from '@/components/text/title_page'
 import NAV from '@/components/nav'
 import TEXTCH001 from '@/components/text/ch001'
 import TEXTCH002 from '@/components/text/ch002'
 import TEXTSECTION0001 from '@/components/text/Section0001'
 import TEXTCH003 from '@/components/text/ch003'
 import TEXTSECTION0002 from '@/components/text/Section0002'
 import TEXTCH004 from '@/components/text/ch004'
 import TEXTSECTION0003 from '@/components/text/Section0003'
 import TEXTCH005 from '@/components/text/ch005'
 import TEXTSECTION0004 from '@/components/text/Section0004'
 import TEXTCH006 from '@/components/text/ch006'
 import TEXTSECTION0005 from '@/components/text/Section0005'
 import TEXTCH007 from '@/components/text/ch007'
 import TEXTSECTION0006 from '@/components/text/Section0006'
 import TEXTCH008 from '@/components/text/ch008'
 import TEXTSECTION0007 from '@/components/text/Section0007'
 import TEXTCH009 from '@/components/text/ch009'
 import TEXTSECTION0008 from '@/components/text/Section0008'
 import TEXTCH010 from '@/components/text/ch010'
 import TEXTSECTION0009 from '@/components/text/Section0009'
 import TEXTCH011 from '@/components/text/ch011'
 import TEXTSECTION0010 from '@/components/text/Section0010'
 import TEXTCH012 from '@/components/text/ch012'
 import TEXTSECTION0011 from '@/components/text/Section0011'
 import TEXTCH013 from '@/components/text/ch013'
 import TEXTSECTION0012 from '@/components/text/Section0012'
 import TEXTCH014 from '@/components/text/ch014'
 import TEXTCH015 from '@/components/text/ch015'
 import TEXTCH016 from '@/components/text/ch016'
 import TEXTCH017 from '@/components/text/ch017'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/nav",
 			"name" : "nav",
 			"component" : NAV
 		},
 		{
 			"path" : "/text/ch001",
 			"name" : "text/ch001",
 			"component" : TEXTCH001
 		},
 		{
 			"path" : "/text/ch002",
 			"name" : "text/ch002",
 			"component" : TEXTCH002
 		},
 		{
 			"path" : "/text/Section0001",
 			"name" : "text/Section0001",
 			"component" : TEXTSECTION0001
 		},
 		{
 			"path" : "/text/ch003",
 			"name" : "text/ch003",
 			"component" : TEXTCH003
 		},
 		{
 			"path" : "/text/Section0002",
 			"name" : "text/Section0002",
 			"component" : TEXTSECTION0002
 		},
 		{
 			"path" : "/text/ch004",
 			"name" : "text/ch004",
 			"component" : TEXTCH004
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js